import React from 'react';
import './dialog.component.scss';
import { Write } from '../write/write.component';
import { Button } from '../button/button.component';

export declare namespace DialogType {
  type Props = {
    className?: string;
    title: string;
    description: string | React.ReactNode;
    onCancel: () => void;
    onConfirm: () => void;
  };
}

export const Dialog = ({
  className,
  title,
  description,
  onCancel,
  onConfirm,
}: DialogType.Props) => {
  return (
    <div
      className={`
        dialog ${className}`}
    >
      <div className="dialog__content">
        <Write
          data={{ item: title }}
          config={{ mode: 'title-small', align: 'center' }}
        />

        {typeof description === 'string' ? (
          <Write
            data={{ item: description }}
            config={{ mode: 'title-small-description', align: 'center' }}
          />
        ) : (
          description
        )}
      </div>

      <div className="dialog__actions">
        <Button
          handleEvent={{
            click: onCancel,
          }}
          config={{ mode: 'fill', text: 'Annuler' }}
        ></Button>
        <Button
          handleEvent={{
            click: onConfirm,
          }}
          config={{ mode: 'stroke', text: 'Confirmer' }}
        ></Button>
      </div>
    </div>
  );
};
